module.exports = __webpack_public_path__ + "img/ss_green-03.ece07c4e.jpg";